module.exports = __webpack_public_path__ + "img/antes_despues_185.357d2a2c.png";